//@ts-check
import SmrClient from "Utils/Requests/SmrClient";

class StatsRequests {
    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'Stats/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {WebStatFilters} filters
     * @returns {Promise<StatWeb>}
     */
    async GetData(filters) {
        return await SmrClient.FetchJson({
            url: 'Stats/GetData',
            method: 'POST',
            body: filters
        });
    }

    /**
     * @param {WebStatFilters} filters
     */
    async ExportData(filters) {
        await SmrClient.FetchDownload({
            url: 'Stats/ExportData',
            method: 'POST',
            body: filters
        });
    }
}

export default new StatsRequests;